// ============================================================================
// PROJECTS CONFIGURATION - Single Source of Truth
// ============================================================================
// MAINNET CONTRACTS - Extracted from Document 1 and integrated
// To add a new presale, simply add a new entry to PROJECTS_CONFIG below.
// All other files will automatically pick up the changes.
import { getMergedProjectsConfig } from "./projectConfig";

const PROJECTS_CONFIG = {
  SIXR: {
    preSale: "0x0EE53a802f7a0d9C89666fb11Aed70db5A2C00e9",
    claim: "0x6f373E20Dc6EA18e03b335D4DE1Fce41CB5eE1cE",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/sixr-main/v1.1/gn",
    label: "SIXR",
    imageSrc: "https://gems.vip/assets/alldetailpages/sixr/main-img.png",
  },
  BYZANLINK: {
    preSale: "0xDf5c53d1A6532a1349440758851B994348bafCed",
    claim: "0x917F407377f0fC2d0c09C369f0d8acD3254813C7",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/byzenlink/v1.1/gn",
    label: "Byzanlink",
    imageSrc: "https://gems.vip/assets/alldetailpages/byzanlink/main-img.png",
  },
  KAI: {
    preSale: "0x766FCcD76346cD34C2CfDb81e11902E9561a3d05",
    specialRound: "0xfa978E22AE9BD456b8A1637959E615F0b0009C69",
    claim: "0x1fecC6F35785613488213A8968e33db578212B89",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/kai-presale/prod/gn",
    label: "KAI",
    imageSrc: "https://gems.vip/assets/alldetailpages/kai/main-img.png",
  },
  NOYA: {
    preSale: "0xcf3bd5b1b02fa79b73b3cc017d51699f246a7b2d",
    claim: "0x798ac68aaaf5569956ed96a6e62ddb233ff5ceaa",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/noya-ai/1.0.0/gn",
    label: "Noya.ai",
    imageSrc: "	https://gems.vip/assets/alldetailpages/noya/main-img.png",
  },
  TIGA: {
    preSale: "0xeecccfd9a1cbf9871f8b9d2e0b8d329faa7246a7",
    claim: "0x52f5ad32b9cc0523e71f3145fcf2bcd94f711d8f",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/tigagraph/prod/gn",
    label: "Tiga",
    imageSrc: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
  },
  XPROTOCOL: {
    preSale: "0x9015294E96Dbe44A84Fa6E1e6eE79dd23CA65D94",
    claim: "0x05123b52e23aefc79cf6c1ef2711b840c2044eda",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/xprotocolgraph/prod/gn",
    label: "Xprotocol",
    imageSrc: "https://gems.vip/assets/alldetailpages/xprotocol/main-img.png",
  },



  CHAINERS: {
    // MAINNET from Doc 1
    preSale: "0x9990b5a321a5571262a2a82e278492c3ccbd8c69",
    claim: "0x9c3786d4107f7b0bcbf82ac1e2f7ec11be450a3c",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/chainer-subgraph/prod/gn",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    institutionGraph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/chainer-subgraph/prod/gn",
    label: "Chainers",
    imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
  },

  SCREX: {
    // MAINNET from Doc 1
    preSale: "0xe593109f04418f780c9d04260c85ee28e5b347e3",
    claim: "0x8720afbde3c7b92f6f928ad81554d62621403c3f",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    institutionGraph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn",
    label: "Screx",
    imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
  },

  LUCKIFY: {
    // MAINNET from Doc 1
    preSale: "0x8BCa408fC6D0a12725F5B8D33a57052E63FF90F6",
    claim: "0x7Ed4FCD6D91AaA338A57d8B543DA50DF1b2bE514",
    graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokenOnly-mainnet-graph/api",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    institutionGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokenOnly-mainnet-graph/api",
    label: "Luckify",
    imageSrc: "/assets/luckify.svg",
  },

  MATCHAIN: {
    // MAINNET from Doc 1
    preSale: "0x153956024667d29aA437Ef26413f3539eF0af42a",
    claim: "0x72097D31138751Ab614bad497Ad0aAE343c39a9b",
    graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/matchain-main/api",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "Matchain",
    imageSrc: "/assets/matchain.svg",
  },

  RAIN: {
    // MAINNET from Doc 1
    preSale: "0x29678cc6145a9FE173417DEf8797Fb22529d1a7e",
    preSaleV2: "0x4c1433a23014a56c7341235298887e56a62B53BF",
    preSaleV3: "0x89b0D65224b3c96430C72e3A8619B923aC866BC7",
    claim: "0x3d92A3c43F142d7eee687DC99489B390dd1e53db",
    claimV2: "0xB1544Ad821b5d74C8DBfC1b58EDEC76947B75cdA",
    claimV3: "0x142A7864C0fd3A264673d0F236C99c0931b7133a",
    institutionPreSale: "0x3d48992a2b04337905040CfD73e8d5e80Eeb2ab9",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-presale-mainnet/v0.0.5-new-version/gn",
    graphV2: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-mainnet-presale-insurance/v0.0.14-new-version/gn",
    graphV3: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-presale-without-Insurance-mainnet/v0.0.3-new-version/gn",
    institutionGraph: "https://api.studio.thegraph.com/query/75549/institution-main-graph/version/latest",
    label: "Rain",
    imageSrc: "/assets/rain.svg",
    useSpecialContract: true,
  },

  ASTRANOVA: {
    // MAINNET from Doc 1
    preSale: "0x24EF0ccaF8F3B4671FcE82005023E85120f6c026",
    preSaleV2: "0x536bd78ea843F37570821639126589D8C5950Cf6",
    claim: "0x1890cF752f1be4D60f3b22168c7A6aFEbd9D74C7",
    claimV2: "0x2D5a000E4C2fb1843FfaB1FE94767D0Fb45f179D",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/astro-nova-live/api",
    graphV2: "https://api.studio.thegraph.com/query/63987/asro-nova-v2/version/latest",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "Astra Nova",
    imageSrc: "/assets/astronova.svg",
    useSpecialContract: true,
  },

  NFA: {
    // MAINNET from Doc 1
    preSale: "0x8c61465F51C95635a43E4D0094f2329Ff5989992",
    claim: "0x84fD533E83B0b869034F3675DE0ABE00eE98a179",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/nfa-mainnet/v1.1/gn",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "NFA",
    imageSrc: "/assets/nfa.svg",
  },

  LEIA: {
    // MAINNET from Doc 1
    preSale: "0x3aEdC9075A8238A68BEc28495ea566f9abcA2840",
    claim: "0xB107140C5737Bfa6dBBe46db6b359Caf6e51524D",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    graph: "https://api.studio.thegraph.com/query/63987/lea-mainnet/version/latest",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "Leia",
    imageSrc: "/assets/leia.svg",
    useSpecialContract: true,
  },

  OLYMPUS: {
    // MAINNET from Doc 1
    preSale: "0xaDF3202480bD62F3dB150E27A0F811f999F253B9",
    claim: "0x1a11428b6F7903024B79aa7843d59895c817a3ad",
    institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
    graph: "https://api.studio.thegraph.com/query/63987/olympus-main/v-1",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "Olypmus",
    imageSrc: "/assets/olympus.svg",
    useSpecialContract: true,
  },

  INCENTIV: {
    // MAINNET from Doc 1
    preSale: "0x20361bC401EA01e5d6E01596c445Af1a48e1171b",
    claim: "0x27E00382b0C3eCd74d1505e8CD73706d79D0Bd54",
    institutionPreSale: "0x09e4f3E65ce7c16566DdFA0D860D4d95a26698ca",
    graph: "https://api.studio.thegraph.com/query/63987/incentive-main/v1.1.1.1",
    institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
    label: "Incentiv",
    imageSrc: "/assets/incentiv-new-logo.svg",
    useSpecialContract: true,
  },

  GEMS: {
    // MAINNET from Doc 1
    preSale: "0x6236e15ab57bAA2d1465660Ef4Ec3B0A8D071090",
    claim: "0x96d7e90E6176466a0D882fc8BA6436021F1AeB06",
    graph: "https://api.studio.thegraph.com/query/63987/gems-presale-main/0.4.1",
    label: "Gems",
    imageSrc: "/assets/gems.svg",
  },

  NODEMINER: {
    // MAINNET from Doc 1
    claim: "0x20Fa1ad4021d1B7373b72De6D77468A7c19C5F22",
    graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-node-staging/api",
    label: "Node Miner",
    imageSrc: "/assets/nodeminer.svg",
    hasPreSale: false,
  },
};
const automationGraph =
  "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/automation-mainnet/main/gn"; // "https://api.studio.thegraph.com/query/63987/automation-mainnet/version/latest";
let { combinedProjects, autoProjects } = await getMergedProjectsConfig(
  PROJECTS_CONFIG,
  automationGraph
);
let projects = combinedProjects || PROJECTS_CONFIG;
let apiProjects = autoProjects;
// ============================================================================
// LEGACY EXPORTS - For backward compatibility with existing code
// ============================================================================
// This section auto-generates the old flat structure from PROJECTS_CONFIG
// so existing code doesn't break

const legacyExports = Object.entries(projects)?.reduce((acc, [key, config]) => {
  // Main contracts
  if (config.preSale) acc[`${key}PreSale`] = config.preSale;
  if (config.claim) acc[`${key}Claim`] = config.claim;
  if (config.graph) acc[`${key}Graph`] = config.graph;

  // Version 2
  if (config.preSaleV2) acc[`${key}PreSaleV2`] = config.preSaleV2;
  if (config.claimV2) acc[`${key}ClaimV2`] = config.claimV2;
  if (config.graphV2) acc[`${key}GraphV2`] = config.graphV2;

  // Version 3
  if (config.preSaleV3) acc[`${key}PreSaleV3`] = config.preSaleV3;
  if (config.claimV3) acc[`${key}ClaimV3`] = config.claimV3;
  if (config.graphV3) acc[`${key}GraphV3`] = config.graphV3;

  // Institution contracts
  if (config.institutionPreSale)
    acc[`${key}InstitutionPreSale`] = config.institutionPreSale;
  if (config.institutionGraph)
    acc[`${key}institutionGraph`] = config.institutionGraph;

  return acc;
}, {});

// ============================================================================
// MAIN ENVIRONMENT OBJECT
// ============================================================================
const Environment = {
  // Projects Configuration (New Way)
  PROJECTS: projects,
  PROJECTS_Fixed: PROJECTS_CONFIG,
  apiProjects: apiProjects,

  // Legacy flat exports (Old Way - for backward compatibility)
  ...legacyExports,
  tokenRegistry: "0x30B3AB585bD14DD2909A53fe700c813e180653eF", //testnet
  // automator: "0x798845BE2D089B28f2e0d58Bc38075Fdedc555eE", //testnet
  automator: "0x256Eb235e6713A5fB84111317dec40baA7c30fC1",

  // Shared Institution Graph
  institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

  // Additional addresses
  NodeMinerTokenRegistry: "0x07AA440a2cc116fB1C01BF135F6d7AFBdd36c57f",

  // Token addresses - MAINNET from Doc 1
  weth: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
  busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  tomi: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
  eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
  usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  wbtc: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
  pepe: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
  link: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  uni: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
  dop: "0x97A9a15168C22B3C137E6381037E1499C8ad0978",
  gems: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc", //MAINNET
  specialDopRound: "0x445aaeDca2D8345705098abcf4c1c823888Ea036",
};

export default Environment;

// let Environment = {
//   PreSale: "0x20361bC401EA01e5d6E01596c445Af1a48e1171b",
//   Claim: "0x27E00382b0C3eCd74d1505e8CD73706d79D0Bd54",
//   InstitutionPreSale: "0x09e4f3E65ce7c16566DdFA0D860D4d95a26698ca",
//   Graph: "https://api.studio.thegraph.com/query/63987/incentive-main/v1.1.1.1",
//   institutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",


//   MATCHAINPreSale: "0x153956024667d29aA437Ef26413f3539eF0af42a",
//   MATCHAINClaim: "0x72097D31138751Ab614bad497Ad0aAE343c39a9b",
//   MATCHAINGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/matchain-main/api",
//   MATCHAINInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   MATCHAINinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   LUCKIFYPreSale: "0x8BCa408fC6D0a12725F5B8D33a57052E63FF90F6",
//   LUCKIFYClaim: "0x7Ed4FCD6D91AaA338A57d8B543DA50DF1b2bE514",
//   LUCKIFYGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokenOnly-mainnet-graph/api",
//   LUCKIFYInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   LUCKIFYinstitutionGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokenOnly-mainnet-graph/api",

//   SCREXPreSale: "0xe593109f04418f780c9d04260c85ee28e5b347e3",
//   SCREXClaim: "0x8720afbde3c7b92f6f928ad81554d62621403c3f",
//   SCREXGraph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn",
//   SCREXInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   SCREXinstitutionGraph:
//     "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn",


//   ///////// LEIA
//   CHAINERSPreSale: "0x9990b5a321a5571262a2a82e278492c3ccbd8c69",
//   CHAINERSClaim: "0x9c3786d4107f7b0bcbf82ac1e2f7ec11be450a3c",
//   CHAINERSGraph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/chainer-subgraph/prod/gn",
//   CHAINERSInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   CHAINERSinstitutionGraph:
//     "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/chainer-subgraph/prod/gn",


//   LEIAPreSale: "0x3aEdC9075A8238A68BEc28495ea566f9abcA2840",
//   LEIAClaim: "0xB107140C5737Bfa6dBBe46db6b359Caf6e51524D",
//   LEIAInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   LEIAGraph:
//     "https://api.studio.thegraph.com/query/63987/lea-mainnet/version/latest",
//   LEIAinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// OLYMPUS

//   OlympusPreSale: "0xaDF3202480bD62F3dB150E27A0F811f999F253B9",
//   OlympusClaim: "0x1a11428b6F7903024B79aa7843d59895c817a3ad",
//   OlympusInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   OlympusGraph: "https://api.studio.thegraph.com/query/63987/olympus-main/v-1",
//   OlympusinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// NFA

//   NFAPreSale: "0x8c61465F51C95635a43E4D0094f2329Ff5989992",
//   NFAClaim: "0x84fD533E83B0b869034F3675DE0ABE00eE98a179",
//   NFAInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   NFAGraph:
//     "https://api.studio.thegraph.com/query/63987/nfa-mainnet/version/latest",
//   NFAinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// ASTRO NOVA

//   AstroNovaPreSale: "0x24EF0ccaF8F3B4671FcE82005023E85120f6c026",
//   AstroNovaPreSaleV2: "0x536bd78ea843F37570821639126589D8C5950Cf6",

//   AstroNovaClaim: "0x1890cF752f1be4D60f3b22168c7A6aFEbd9D74C7",
//   AstroNovaClaimV2: "0x2D5a000E4C2fb1843FfaB1FE94767D0Fb45f179D",

//   AstroNovaInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   AstroNovaGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/astro-nova-live/api",

//   AstroNovaGraphV2:
//     "https://api.studio.thegraph.com/query/63987/asro-nova-v2/version/latest",

//   AstroNovainstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// RAIN

//   RainPreSale: "0x29678cc6145a9FE173417DEf8797Fb22529d1a7e",
//   RainPreSaleV2: "0x4c1433a23014a56c7341235298887e56a62B53BF",
//   RainPreSaleV3: "0x89b0D65224b3c96430C72e3A8619B923aC866BC7",

//   RainClaim: "0x3d92A3c43F142d7eee687DC99489B390dd1e53db",
//   RainClaimV2: "0xB1544Ad821b5d74C8DBfC1b58EDEC76947B75cdA",
//   RainClaimV3: "0x142A7864C0fd3A264673d0F236C99c0931b7133a",

//   RainInstitutionPreSale: "0x3d48992a2b04337905040CfD73e8d5e80Eeb2ab9", // cahnge by jawad
//   RainGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/rain-presale-mainnet/api",

//   RainGraphV2:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/rain-mainnet-presale-insurance/api",

//   RainGraphV3:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/rain-presale-without-Insurance-mainnet/api",

//   RaininstitutionGraph:
//     "https://api.studio.thegraph.com/query/75549/institution-main-graph/version/latest",

//   ///////// MINERS CLAIMS
//   MinersClaim: "0x20Fa1ad4021d1B7373b72De6D77468A7c19C5F22",
//   MinersGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-node-staging/api",

//   /////// GEMS MAINNET

//   GemsGraph:
//     "https://api.studio.thegraph.com/query/63987/gems-presale-main/0.4.1", //MAINNET
//   GemsClaim: "0x96d7e90E6176466a0D882fc8BA6436021F1AeB06", //MAINNET
//   GemsPreSale: "0x6236e15ab57bAA2d1465660Ef4Ec3B0A8D071090", //MAINNET

//   NodeMinerTokenRegistry: "0x07AA440a2cc116fB1C01BF135F6d7AFBdd36c57f", //TESTNET

//   busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
//   tomi: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
//   eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
//   usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
//   wbtc: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
//   pepe: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
//   link: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
//   uni: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
//   dop: "0x97A9a15168C22B3C137E6381037E1499C8ad0978",
//   gems: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc", //MAINNET
// };
// export default Environment;